import { createContext, useContext, useState, useCallback } from "react";

const STRINGS = {
  es: {
    arcade: "★ NICARAGUA ARCADE ★",
    subtitle: "¡Una aventura pinolera!",
    start: "► JUGAR / START",
    scores: "★ PUNTAJES",
    controls: "Mové: ← → / A D · Saltá: ESPACIO · Poder: K · Bailá: J",
    chooseChar: "ELEGÍ TU PERSONAJE",
    swipeHint: "Deslizá para ver más",
    back: "◄ VOLVER",
    playingWith: "Jugando con",
    chooseLevel: "ELEGÍ EL NIVEL",
    levelsSection: "NIVELES",
    bonusLevelsSection: "NIVELES BONUS",
    featuredLevelsSection: "NIVELES ESPECIALES DESTACADOS",
    featuredBadge: "DESTACADO",
    featuredLabel: "ESPECIAL",
    couponOff: "DTO",
    sponsoredBy: "Con",
    couponTeaser: (p) => `Completá el nivel y recibí ${p}% de descuento en tu próxima cuenta.*`,
    etBoardTitle: "GIFT CARD $25",
    etBoardSub: (d) => `Reto de ${d} días · el #1 se lleva la gift card`,
    etBoardPrize: "PREMIO",
    etBoardPoweredBy: "Powered by NicaBros",
    etBoardEmpty: "Todavía no hay corridas. ¡Sé el primero!",
    etBoardPlayers: (n) => `${n} jugador${n === 1 ? "" : "es"} compitiendo`,
    etBoardYou: "Vos",
    etBoardYourRank: (r, s) => `Tu puesto: #${r} · ${s} pts`,
    etBoardRegister: "Registrate para entrar al reto",
    etBoardRegisterHint: "Solo jugadores registrados entran a la tabla y pueden ganar la gift card.",
    etScoreSaved: "¡Tu corrida entró al Reto Gift Card!",
    etScorePending: (s) => `Tu corrida: ${s} pts — registrate para entrar al reto y competir por la gift card.`,
    etViewBoard: "Ver tabla",
    gcRules: "MODO EXTREMO · completá el nivel · más rápido · más 🍺 y puntos · menos golpes",
    gcFormula: (b, t, d) => `Puntos = puntaje + 🍺×${b} + bonus de tiempo (${t}/seg) − ${d} por golpe`,
    gcPlay: "JUGAR EL RETO (EXTREMO)",
    gcPlayHint: "El reto se juega en modo Extremo. Completá el nivel para entrar a la tabla.",
    gcEntryLine: (r, p) => `Puesto #${r} · ${p} pts`,
    gcTryChallenge: "¿Querés la gift card de $25? Jugá el Reto en modo Extremo.",
    gcColTime: "Tiempo",
    gcColBeers: "🍺",
    gcColHits: "Golpes",
    discountsUnlocked: "descuentos",
    discountsBtn: "Descuentos de marcas",
    signInForDiscounts: "Iniciá sesión para ver descuentos",
    leadCapturePrompt: "¿Solo querés ofertas y novedades? Dejanos tu correo",
    leadCaptureBtn: "Enviar",
    leadCaptureThanks: "¡Gracias! Te avisaremos de novedades y descuentos.",
    changeChar: "◄ CAMBIAR PERSONAJE",
    level: "NIVEL",
    locked: "Bloqueado",
    play: "Jugar",
    volcanoBonus: "BONUS: VOLCÁN",
    volcanoBonusName: "Volcano Boarding · Cerro Negro",
    bonusLockedHint: "Terminá los 3 niveles para desbloquear",
    playBonus: "▶ JUGAR BONUS",
    rodeoBonus: "BONUS: RODEO",
    rodeoBonusName: "Monta de Toros · Rodeo Nica",
    rodeoTitle: "RODEO NICA",
    rodeoTimeLeft: "AGUANTA",
    rodeoBalance: "EQUILIBRIO",
    rodeoSteerHint: "para mantener el equilibrio",
    rodeoThrown: "¡TE TUMBÓ!",
    rodeoSurvived: "Aguantaste",
    rodeoExtraChance: "¡Te queda una oportunidad más!",
    rodeoRideAgain: "MONTAR DE NUEVO",
    rodeoPerfect: "¡JINETE CAMPEÓN!",
    rodeoResultTitle: "¡BUEN JINETE!",
    rodeoLevelCard: "NIVEL 7",
    rodeoLevelCardName: "Corrida de Toros",
    rodeoLevelName: "NIVEL RODEO",
    rodeoLevelGoal: "¡LLEGA A LA META!",
    rodeoBossLabel: "¡JEFE FINAL!",
    rodeoChampion: "¡CAMPEÓN!",
    rodeoBossBeaten: "¡Derrotaste al Jefe de la Corrida!",
    rodeoShare: "📲 COMPARTIR MI HAZAÑA",
    rodeoJump: "SALTA",
    rodeoDuck: "AGÁCHATE",
    rodeoMove: "MUÉVETE",
    backToMenu: "MENÚ",
    rodeoBest: "Mejor",
    topScores: "★ MEJORES PUNTAJES ★",
    loading: "Cargando...",
    loadingGame: "CARGANDO...",
    noScores: "¡Todavía nadie juega! Sé el primero.",
    name: "NOMBRE",
    pts: "PTS",
    menu: "◄ MENÚ",
    win: "¡GANASTE!",
    gameOver: "GAME OVER",
    finalScore: "PUNTAJE FINAL",
    beersLabel: "Cervezas",
    yourName: "TU NOMBRE",
    saving: "GUARDANDO...",
    saveScore: "★ GUARDAR PUNTAJE",
    saved: "¡Puntaje guardado! 🎉",
    nextLevel: "► SIGUIENTE NIVEL",
    playOnTier: (label) => `► JUGAR EN ${label} (+monedas)`,
    coinsEarned: (n) => `🪙 +${n} monedas`,
    gigantonaRewardTitle: "¡DESBLOQUEASTE LA GIGANTONA!",
    gigantonaRewardBody: "¡Venciste a la abuela jefa del Nivel 3! La Gigantona es tuya GRATIS. 🎉",
    gigantonaRewardCta: "¡GENIAL, A JUGAR!",
    rewardFreeTag: "¡GRATIS!",
    langAutoToast: "Idioma: Español · tocá ES/EN arriba para cambiar",
    partnerCodeLabel: "CÓDIGO",
    partnerShowCode: "Ver código de descuento",
    partnerPopupTitle: "¡Gracias por ser parte de la Comunidad NicaBros!",
    partnerPopupBody: (brand) => `Presentá este código en ${brand} para tu descuento de jugador NicaBros.`,
    partnerPopupBodyGeneric: "Presentá este código para tu descuento de jugador NicaBros.",
    partnerVisit: "Visitar sitio",
    partnerClose: "Cerrar",
    partnersPageTitle: "Regalos y Descuentos · Red y Socios de NicaBros",
    partnersPageSub: "Mostrá estos códigos a nuestros socios y obtené regalos y descuentos por ser jugador NicaBros.",
    partnersGateTitle: "🎁 Regalos y descuentos exclusivos",
    partnersGateBody: "Creá tu cuenta gratis e iniciá sesión para ver todos los regalos y descuentos de la Red y los Socios de NicaBros.",
    partnersGcTitle: "GIFT CARDS DE $25 · ALIADOS DEL MES",
    partnersGcSub: "Jugá el nivel del aliado en modo Extremo: el puntaje más alto en 30 días se lleva la gift card de $25.",
    partnersGcTeaser: "+ Gift cards mensuales de $25 de nuestros aliados",
    partnersGateLogin: "Iniciar sesión / Registrarse",
    partnersWeeklyTitle: "🔒 Acceso semanal",
    partnersWeeklyBody: "Iniciá sesión esta semana para ver los descuentos. ¡Volvé cada semana por nuevas ofertas!",
    partnersWeeklyBtn: "Iniciar sesión de nuevo",
    partnersEmpty: "Pronto habrá descuentos de socios. ¡Volvé pronto!",
    partnersShareCopy: "Copiar enlace",
    partnersShareWhats: "Compartir por WhatsApp",
    partnersShareMsg: "🎮🎁 ¡Mirá los descuentos de socios de NicaBros! Jugá y mostrá tu código para ahorrar:",
    partnersLinkCopied: "¡Enlace copiado!",
    rewardUnlockedTitle: (name) => `¡DESBLOQUEASTE ${name}!`,
    rewardUnlockedBody: (name) => `¡Venciste al jefe y ganaste un personaje GRATIS! Ya podés jugar con ${name}. 🎉`,
    level3Reward: "🎁 Vencé a la jefa → La Gigantona GRATIS",
    level7Reward: "🎁 Vencé al toro → El Enano Cabezón GRATIS",
    freeCharBadge: "🎁 PERSONAJE GRATIS",
    collectionTitle: "Colección de Personajes",
    collectionBtn: "Colección",
    collectionNudge: "🔓 ¡Desbloqueo cerca!",
    storyChallenges: "🎵 ¡Tu Viaje en NicaBros!",
    challengeLeonName: "El Rugido de León",
    challengeLeonDesc: "Vencé el Nivel 4 (León) con JavyDade",
    challengeBluefieldsName: "Ritmo de Bluefields",
    challengeBluefieldsDesc: "Completá el Nivel 5 (Bluefields) con NicaFlow",
    challengeComplete: "✓ ¡Completado!",
    challengeLocked: "🔒 Bloqueado",
    badgeEarnedTitle: "¡INSIGNIA DESBLOQUEADA!",
    badgeEarnedBody: (name) => `Completaste el reto "${name}". ¡Insignia añadida a tu colección! 🎉`,
    badgeEarnedCta: "¡GENIAL!",
    collectionProgress: (n, total) => `${n} / ${total} desbloqueados`,
    collectionUnlocked: "✓ Desbloqueado",
    unlockBeatLevel: (n) => `🎁 Vencé el Nivel ${n}`,
    unlockFreeChar: "Gratis",
    collectionHint: "¡Desbloqueá a todos! Ganá monedas jugando o vencé a los jefes.",
    retry: "↻ REINTENTAR",
    playManagua: "► JUGAR MANAGUA",
    pauseTitle: "PAUSA",
    resume: "► CONTINUAR",
    fiesta: "FIESTA",
    fiestaOn: "¡FIESTA!",
    jefa: "★ LA JEFA ★",
    music: "MÚSICA",
    chooseSong: "ELEGÍ TU CANCIÓN",
    close: "CERRAR",
    autoMusic: "Auto (por nivel)",
    tag_dongregorio: "Don Positivismo",
    desc_dongregorio: "Corre rapidísimo, salta más alto, doble salto y dash (K).",
    tag_chasedawson: "Jugador de Béisbol de Nicaragua",
    desc_chasedawson: "Batea un jonrón (K) que sale volando y tumba enemigos.",
    power_chasedawson: "JONRÓN",
    tag_jorge: "Curious123 Soccer Camps",
    desc_jorge: "Patea 3 balones de fútbol (K) a la vez para tumbar enemigos.",
    tag_laborracha: "La Reina De La Fiesta",
    desc_laborracha: "Lanza botellas de cerveza (K) para tumbar enemigos a distancia.",
    tag_ranchero: "El Vaquero Pinolero",
    desc_ranchero: "Corre rápido, doble salto y da un MACHETAZO (K) de largo alcance.",
    tag_surfista: "La Leyenda De San Juan",
    desc_surfista: "Ágil surfista que da un KARATAZO (K) a los enemigos de enfrente.",
    tag_pandillero: "El Más Vivo Del Barrio",
    desc_pandillero: "Lanza piedras (K) para tumbar enemigos a distancia.",
    tag_influencer: "Pancho al Volante",
    tag_nicaflow: "Seguime en TikTok",
    desc_influencer: "Patea balones de fútbol (K) que tumban enemigos. ¡SÚPER RÁPIDO + DOBLE SALTO!",
    tag_angelmick: "Nueva Música Ya Disponible",
    desc_angelmick: "Canta notas musicales (K) que tumban enemigos. ¡SÚPER RÁPIDO + DOBLE SALTO!",
    tag_gueguense: "El Pícaro Enmascarado",
    desc_gueguense: "TRIPLE SALTO + lanza maracas mágicas (K) que tumban enemigos. ¡Ideal para niveles difíciles!",
    tag_gigantona: "La Reina Del Carnaval",
    desc_gigantona: "TRIPLE SALTO altísimo + GIRO veloz (K) que noquea a los enemigos alrededor. ¡Domina cualquier nivel!",
    power_influencer: "BALONAZO NICA",
    power_angelmick: "NOTAS MUSICALES",
    power_dongregorio: "FRITANGAZO",
    power_ranchero: "MACHETAZO",
    power_pandillero: "PEDRADA",
    power_laborracha: "BOTELLAZO",
    power_jorge: "TRIPLE BALONAZO",
    power_surfista: "KARATAZO",
    power_gueguense: "MARACAZO MÁGICO",
    power_gigantona: "GIRO GIGANTE",
    power_javydade: "NACATAMALAZO",
    tag_javydade: "Nueva Música Ya Disponible",
    desc_javydade: "Lanza nacatamales (K) que tumban enemigos. ¡SÚPER RÁPIDO + DOBLE SALTO!",
    link_javydade: "Seguí a @JavyDade",
    act_nacatamal: "Lanza Nacatamales",
    act_fritanga: "Lanza Fritangas",
    act_throw: "Lanza Botellas",
    act_ball: "Patea Balones",
    actTriplePlay: "Triple Play",
    powerTriplePlay: "TRIPLE PLAY",
    act_homerun: "Batea un Jonrón",
    act_notes: "Notas Musicales",
    act_rock: "Lanza Piedras",
    act_machete: "Machetazo",
    act_chop: "Karatazo",
    act_strength: "Pisotón Poderoso",
    act_speed: "Dash Veloz",
    tag_elvin: "El Prodigio",
    link_elvin: "Seguí a ElvinEspinoza",
    power_elvin: "GANCHO DERECHO",
    desc_elvin: "Lanza rayos eléctricos (K) desde su guante que tumban enemigos. ¡SÚPER RÁPIDO + DOBLE SALTO!",
    act_electric: "Rayos Eléctricos",
    tag_nacatamal: "Nacatambuche",
    power_nacatamal: "PANAZO",
    desc_nacatamal: "¡Súper rápido y doble salto! Lanza pan (K) que tumba enemigos.",
    act_bread: "Lanza Pan",
    tag_enanocabezon: "Pareja de La Gigantona",
    power_enanocabezon: "CABEZAZO",
    desc_enanocabezon: "Da un cabezazo (K) que noquea a los enemigos de enfrente. ¡Doble salto!",
    act_headbutt: "Cabezazo",
    tag_elespanol: "Del Toro Huaco",
    power_elespanol: "SONAJA MÁGICA",
    desc_elespanol: "Lanza maracas de morro (K) para tumbar enemigos a distancia. ¡Triple salto!",
    act_rattle: "Lanza la Sonaja",
    act_maraca: "Lanza Maracas",
    act_spin: "Giro Veloz",
    tabVolcano: "Volcán",
    tabOcean: "Buceo",
    bonusTop5: "TOP 5",
    bossLevelBadge: "JEFE ESPECIAL",
    perkDoubleJump: "Doble Salto",
    perkTripleJump: "Triple Salto",
    perkSuperFast: "Súper Rápido",
    perkFast: "Veloz",
    influencedBy: "Inspirado por",
    soundtrack: "Escuchar en Spotify",
    link_dongregorio: "Visitá mi sitio web",
    giftsBanner: "🎁 PRÓXIMAMENTE: ¡los mejores jugadores ganarán regalos GRATIS de nuestros socios y patrocinadores!",
    settings: "AJUSTES",
    soundLabel: "Sonido",
    soundOn: "Encendido",
    soundOff: "Apagado",
    musicVolume: "Volumen Música",
    sfxVolume: "Volumen Efectos",
    restartLevel: "↻ REINICIAR NIVEL",
    exitToMenu: "✕ SALIR AL MENÚ",
    shareGame: "📣 COMPARTIR NICA BROS",
    shareWin: "📣 COMPARTIR HAZAÑA",
    shareScore: "📤 COMPARTIR PUNTAJE",
    linkCopied: "¡Enlace copiado! Compartilo con tus amigos 🎉",
    shareText: "¡Estoy jugando Nica Bros 🇳🇮 — una aventura pinolera! Vení a jugar conmigo 🎮",
    shareWinText: "¡Hice {score} puntos en Nica Bros 🇳🇮 con {char}! ¿Me podés ganar? 🎮",
    bonusTitle: "🌋 VOLCANO BOARDING",
    bonusSub: "¡Bajá el Cerro Negro y juntá córdobas!",
    bonusPromptTitle: "¡BONO DE VOLCANO BOARDING!",
    bonusPromptBody: "Bajá el Cerro Negro en tabla y juntá córdobas extra para tu puntaje. ¿Querés jugarlo?",
    bonusPlay: "JUGAR BONO",
    bonusSkip: "Saltar",
    bonusReady: "¡PREPARATE!",
    bonusSteer: "◄ ► para mover",
    cordobas: "CÓRDOBAS",
    bonusResultTitle: "¡PURO COCHE!",
    bonusResultMsg: "Juntaste {n} de 100 córdobas",
    bonusBonus: "BONUS",
    continueBtn: "► CONTINUAR",
    bonusPerfect: "¡PERFECTO! 💯",
    cordobasCol: "C$",
    attemptOf: (n) => `INTENTO ${n} DE 2`,
    bonusCountGo: "¡VAMOS!",
    bestSoFar: "Mejor hasta ahora",
    oceanBonus: "BONUS: BUCEO",
    oceanBonusName: "Buceo del Tesoro · Corn Island",
    oceanLockedHint: "Terminá Corn Island para desbloquear",
    oceanPromptTitle: "¡BONO: BUCEO DEL TESORO!",
    oceanPromptBody: "Bucea más profundo, juntá córdobas, esquivá los peces y llegá al cofre del tesoro para ganar el trofeo NicaBros de oro. ¿Querés jugarlo?",
    oceanTitle: "🌊 BUCEO DEL TESORO",
    oceanSteer: "◄ ► ▲ ▼ para nadar",
    oceanDepth: "¡Bucea más profundo!",
    oceanResultTitle: "¡TESORO ENCONTRADO!",
    trophyTitle: "TROFEO NICABROS DE ORO",
    trophySaved: "🏆 Trofeo guardado en tu perfil",
    trophySignin: "Iniciá sesión para guardar tu trofeo",
    diveKO: "¡TE NOQUEARON!",
    diveKOBody: "Te golpearon 3 peces. ¡Tenés un intento más para terminar desde donde quedaste!",
    diveContinueHere: "SEGUIR DESDE AQUÍ",
    diveKOFinal: "¡TE NOQUEARON!",
    diveKOFinalBody: "Te quedaste sin intentos. ¡Te llevás los córdobas que juntaste!",
    hapticsLabel: "Vibración",
    sectionFood: "Auténtica de Comida",
    act_cream: "Exprime Crema",
    act_tornado: "Lanza Tornados",
    tag_mercado: "El Unico OneTime",
    power_mercado: "KO de Derecha",
    link_mercado: "Seguí @TheOnlyDanielMercado",
    tag_isaacreyes: "Actor y Cantante",
    power_isaacreyes: "PODER ESTELAR",
    link_isaacreyes: "Seguí @IsaacReyes",
    act_starnote: "Estrellas y Notas",
    act_hypno: "Puño Hipnótico",
    tag_jahoskachamorro: "La Reina del Ring",
    power_jahoskachamorro: "PUÑO HIPNÓTICO",
    link_jahoskachamorro: "Seguí @JahoskaChamorro",
    attemptDone: (n) => `¡INTENTO ${n} LISTO!`,
    ready2nd: "Tenés un intento más. ¿Listo?",
    start2nd: "► 2DO INTENTO",
    difficulty: "DIFICULTAD",
    diffFacil: "FÁCIL",
    diffNormal: "NORMAL",
    diffExtremo: "EXTREMO",
    diffFacilDesc: "Más vidas, enemigos lentos",
    diffNormalDesc: "El reto clásico pinolero",
    diffExtremoDesc: "☠️ Brutal: pocas vidas, todo más rápido",
    newBest: "¡NUEVO RÉCORD!",
    best: "Mejor",
    dailyChallenge: "RETO DIARIO",
    today: "Hoy",
    newRecord: "¡NUEVO TIEMPO!",
    tabTop: "TOP",
    tabDaily: "DIARIO",
    tabSpeedrun: "VELOCIDAD",
    timeCol: "TIEMPO",
    shareRank: "📣 COMPARTIR MI PUESTO",
    shareGeneric: "📣 COMPARTIR TABLA",
    rankShareText: (r, s) => `¡Voy #${r} en Nica Bros con ${s} puntos! 🇳🇮 ¿Me ganás?`,
    boardShareText: "¡Jugá Nica Bros y metete en la tabla de líderes! 🇳🇮🍺",
    rankShared: "¡Compartido! 🎉",
    rankCopied: "¡Copiado al portapapeles! 🎉",
    cardSaved: "¡Imagen guardada y enlace copiado! Pegalo en WhatsApp o Instagram para que jueguen 📲",
    cardShareFail: "No se pudo compartir. Intentá de nuevo.",
    notRanked: "Jugá una partida para entrar en la tabla 🎮",
    installTitle: "¡Guardá Nica Bros en tu teléfono!",
    installBenefit: "📲 ¡Se juega MUCHO mejor desde el teléfono! Pantalla completa, más rápido, sin la barra del navegador y con un toque para jugar.",
    installSubtitle: "El juego se disfruta mejor cuando lo guardás en tu pantalla de inicio. ¡Pantalla completa y un toque para jugar!",
    installIos1: "Tocá el botón Compartir (el cuadro con la flecha ↑) abajo en Safari.",
    installIos2: "Deslizá y tocá «Agregar a inicio».",
    installIos3: "Tocá «Agregar» — ¡luego abrí Nica Bros desde tu pantalla de inicio!",
    installAndroid1: "Tocá el menú ⋮ (arriba a la derecha de Chrome).",
    installAndroid2: "Tocá «Agregar a pantalla de inicio» o «Instalar app».",
    installAndroid3: "Tocá «Agregar» — ¡luego abrí Nica Bros desde tu pantalla de inicio!",
    installDesktop1: "Hacé clic en el ícono de instalar ⊕ en la barra de direcciones.",
    installDesktop2: "Hacé clic en «Instalar» para guardarlo como app.",
    installGotIt: "¡LISTO, A JUGAR!",
    giftsTitle: "🎁 ¡Ganá regalos semanales!",
    giftsBody: "Registrate y activá las notificaciones para saber si sos ganador de la semana de nuestros patrocinadores.",
    giftsSignup: "Registrate — ¡es gratis!",
    giftsSignedIn: "Ya estás registrado ✓",
    allowNotifs: "Activar notificaciones",
    notifsOn: "Notificaciones activadas ✓",
    competingForGift: "jugadores compiten por el regalo de esta semana",
    tabGifts: "🎁 Regalos",
    tabInstall: "📱 Guardar app",
    otherDevice: "¿Otro dispositivo?",
    installLater: "Quizás después",
    yourDevice: "Tu dispositivo",
    saveAs: "Guardar como",
    loginToSave: "Creá un perfil para guardar tu puntaje en la tabla 🏆",
    createProfileSave: "Crear perfil / Iniciar sesión",
    scoreEmailCta: "¿Querés recibir recordatorios del juego? 🔔",
    scoreEmailPlaceholder: "Tu correo electrónico",
    scoreEmailBtn: "Guardar",
    scoreEmailThanks: "¡Listo! Te enviaremos recordatorios. 🔔",
    scoreEmailInvalid: "Ingresá un correo válido",
    scoreEmailFail: "No se pudo guardar, intentá de nuevo",
    orCreateProfile: "o creá un perfil para guardar tu puntaje 🏆",
    titleSettings: "AJUSTES",
    saveToPhone: "Guardar en mi teléfono",
    shareGame: "Compartir Nica Bros",
    language: "Idioma",
    howToPlay: "Cómo jugar",
    settingsHelp: "Movete con ← → (o A/D), saltá con ESPACIO, usá tu poder con K y bailá con J.",
    dailyReminders: "Recordatorios diarios",
    remindersEnabled: "¡Recordatorios activados! 🔔",
    remindersDisabled: "Recordatorios desactivados",
    remindersDenied: "Permiso de notificaciones denegado",
    remindersUnsupported: "En iOS, primero guardá el juego en tu pantalla de inicio para activar notificaciones.",
    notifyOptInTitle: "¡Activá las notificaciones!",
    notifyOptInBody: "Recibí avisos de premios semanales, nuevos niveles y retos de tus amigos. ¡No te perdás nada!",
    notifyOptInYes: "Activar notificaciones",
    notifyOptInLater: "Ahora no",
    notifyOptInDone: "¡Notificaciones activadas! 🔔",
    notifyOptInFail: "No se pudieron activar las notificaciones",
    finaleTag: "¡NICARAGUA COMPLETADA!",
    finaleTitle: "¡LO LOGRASTE!",
    levelCompleteTag: "¡NIVEL COMPLETADO!",
    levelCompleteTitle: "¡BIEN AHÍ!",
    levelUnlocked: (n) => `🌋 ¡Desbloqueado: ${n}!`,
    ptsShort: "pts",
    level4Soon: "Nivel 4 — ¡Próximamente!",
    level4Help: "Ayudanos a crear el próximo nivel y los nuevos personajes. ¡Tu idea puede estar en el juego!",
    helpCreate: "AYUDAR A CREAR EL NIVEL 7",
    finishedThanksTitle: "¡COMPLETASTE NICA BROS!",
    finishedThanksBody: "¡Gracias por tu apoyo, pinolero! 🇳🇮 Dejanos una reseña y contanos qué te pareció.",
    rateGame: "CALIFICAR EL JUEGO",
    reviewIntroFinish: "¡Terminaste los 4 niveles! 🎉 Gracias por jugar. Dejá tu reseña pública.",
    shareVictory: "Compartir mi victoria",
    victoryShareText: (c, s) => `¡Completé Nica Bros con ${c} y ${s} puntos! 🇳🇮🏆 ¿Podés superarme?`,
    signIn: "INICIAR SESIÓN",
    signUp: "CREAR CUENTA",
    username: "Usuario",
    age: "Edad",
    ageError: "Ingresá una edad válida.",
    email: "Correo",
    password: "Contraseña",
    lockedChar: "BLOQUEADO",
    comingSoon: "¡PRÓXIMAMENTE!",
    comingSoonBadge: "PRONTO",
    guestStar: "Invitación Especial",
    newBadge: "NUEVO",
    newCharsTitle: "¡NUEVOS PERSONAJES!",
    newCharsBody: "Ya están disponibles nuevos personajes. ¡Elegí el tuyo y a jugar!",
    newLevelTitle: "¡NUEVO NIVEL + BONUS!",
    newCharsCta: "JUGAR AHORA",
    newCharsLater: "Ahora no",
    sectionGuests: "Invitados Especiales Nicaragüenses",
    sectionInvited: "Personajes Invitados Especiales",
    sectionCultural: "Personajes Culturales",
    sectionOriginals: "Personajes Originales",
    inviteToUnlock: (n) => `Invitá ${n} amigos`,
    coins: "monedas",
    coinBalance: (n) => `🪙 ${n} monedas`,
    unlockForCoins: (n) => `Desbloquear · ${n} 🪙`,
    notEnoughCoins: "No tenés suficientes monedas",
    signInToUnlock: "Iniciá sesión para ganar y usar monedas",
    dailyCoinEarned: "🪙 ¡+1 moneda por jugar hoy!",
    dailyStreakToast: (n) => `🔥 ¡Racha de ${n} día${n === 1 ? "" : "s"}! +1 moneda`,
    streakBonusToast: (b) => `🎁 ¡Bono de racha! +${b} monedas`,
    streakBadgeTitle: "Racha diaria — ¡volvé cada día!",
    earnCoinsHint: "Ganá 1 moneda por día · 5 por tu primer amigo, +1 por cada amigo más",
    charUnlocked: (name) => `🔓 ¡Desbloqueaste a ${name}!`,
    charUnlockedDesc: "Tus invitaciones valieron la pena. ¡Ya podés jugar con este personaje!",
    welcomeBonusTitle: "🎁 ¡Bienvenido a Nica Bros!",
    welcomeBonusBody: (n) => `Te regalamos ${n} monedas para que empieces. ¡Usalas para desbloquear un personaje ahora mismo!`,
    welcomeBonusCta: "Desbloquear un personaje",
    welcomeBonusDismiss: "Ahora no",
    challengeStartToast: (n, s) => `🎯 ¡Superá a ${n}: ${s} pts!`,
    challengeYouWon: (n) => `🏆 ¡Le ganaste a ${n}!`,
    challengeYouLost: (n, s) => `Te faltó. ${n} hizo ${s} pts — ¡reintentá!`,
    challengeShareText: (s) => `Te reto en Nica Bros 🇳🇮 — hice ${s} pts. ¿Podés superarme? Jugá acá:`,
    signInToUnlock: "Iniciá sesión para desbloquear personajes invitando amigos",
    noAccount: "¿No tenés cuenta? Registrate",
    haveAccount: "¿Ya tenés cuenta? Iniciá sesión",
    suggestIdeas: "SUGERIR IDEAS",
    suggestSignIn: "Iniciá sesión para sugerir una idea",
    ideasTitle: "IDEAS DE LA COMUNIDAD",
    ideaTitle: "Título de tu idea",
    ideaDesc: "Describí tu idea (opcional)",
    addIdea: "AÑADIR IDEA",
    ideaThanks: "¡Gracias por tu idea! 🎉",
    deleteIdea: "Borrar idea",
    clearAllIdeas: "Borrar todas las ideas",
    ideaDeleted: "Idea eliminada",
    confirmDeleteIdea: "¿Borrar esta idea?",
    confirmDeleteAllIdeas: "¿Borrar TODAS las ideas? Esto no se puede deshacer.",
    noIdeas: "¡Sé el primero en sugerir!",
    cat_all: "Todas",
    cat_level: "Nivel",
    cat_boss: "Jefe",
    cat_feature: "Función",
    send: "ENVIAR",
    cancel: "CANCELAR",
    adminTitle: "PANEL ADMIN",
    adminDenied: "Acceso denegado",
    activeNow: "Activos ahora",
    playersToday: "Jugadores hoy",
    playersWeek: "Esta semana",
    playersMonth: "Este mes",
    minutesToday: "Minutos hoy",
    hoursTotal: "Horas total",
    registeredUsers: "Registrados",
    sessionsAll: "Partidas",
    refresh: "ACTUALIZAR",
    emailDigest: "ENVIARME RESUMEN",
    digestSent: "Resumen enviado a",
    resetScores: "REINICIAR PUNTAJES",
    confirmResetScores: "¿Borrar TODOS los puntajes? Esto reinicia la tabla de líderes y no se puede deshacer.",
    scoresReset: "Puntajes reiniciados",
    playersList: "PERFILES REGISTRADOS",
    exportCsv: "EXPORTAR CSV",
    brandPartnersSwipe: "Desliza para ver más",
    mkBizTitle: "Sé un Socio de Marca",
    mkBizIntro: "¿Tienes un negocio? Ofrece un descuento a los jugadores de Nica Bros y aparece en nuestras vallas del juego.",
    mkBizWhatsappNote: "Después de aplicar, escríbenos por WhatsApp para conectarnos, enviarnos tu imagen/video y coordinar el descuento. Nosotros subimos y aprobamos tu valla para hacer la alianza oficial.",
    mkBizConnectWhatsapp: "Conéctate por WhatsApp",
    mkBizCompany: "Nombre de la empresa",
    mkBizCity: "Ciudad",
    mkBizOffer: "Tu oferta / descuento",
    mkBizCode: "Código para el personal (los jugadores lo muestran al reclamar)",
    mkBizExpires: "La oferta vence",
    mkBizLink: "Enlace para compartir con los jugadores",
    mkBizWhatsappField: "Tu WhatsApp",
    mkBizEmail: "Tu correo",
    mkBizName: "Tu nombre",
    mkBizSubmit: "Solicitar alianza",
    mkBizThanks: "¡Gracias! Revisaremos tu oferta y te contactaremos.",
    mkStatVisitors: "Visitantes totales",
    mkStatSessions: "Sesiones totales",
    mkStatGames: "Partidas jugadas",
    mkLiveData: "Datos en vivo · se actualizan automáticamente. Al",
    mkSponsorMediaKit: "Kit de Medios para Patrocinadores",
    mkCopyLink: "Copiar enlace",
    mkSavePdf: "Guardar PDF",
    mkReportSubtitle: "Reporte de Audiencia y Alcance",
    mkUpdated: "Actualizado",
    mkStatTotalPlayers: "Jugadores totales",
    mkStatMonthlyActive: "Activos al mes",
    mkStatThisWeek: "esta semana",
    mkStatPlayHours: "Horas de juego",
    mkStatScreenTime: "tiempo total en pantalla",
    mkStatAvg: "prom",
    mkAdInventoryTitle: "Inventario de anuncios en el juego",
    mkAdInventoryDesc: "Impresiones estimadas de vallas por nivel/ciudad — tu marca en los letreros del juego.",
    mkColLevelCity: "NIVEL / CIUDAD",
    mkColImpressions: "IMPRESIONES",
    mkColPlayers: "JUGADORES",
    mkColExposure: "EXPOSICIÓN (MIN)",
    mkNoLevelData: "Aún no hay datos de niveles.",
    mkImpressionsLabel: "impresiones de anuncio",
    mkBillboardsTitle: "Espacios de vallas (2 por nivel)",
    mkBbDescA: "Cada ciudad tiene una valla de ",
    mkSlotStartWord: "INICIO",
    mkBbDescB: " (intro del nivel) y una premium de ",
    mkSlotEndWord: "FIN",
    mkBbDescC: " (justo antes de la meta — máxima atención). Reserva una posición abajo.",
    mkSlotEnd: "FIN · antes de la meta",
    mkSlotStart: "INICIO · intro del nivel",
    mkBooked: "RESERVADO",
    mkReserve: "RESERVAR",
    mkYourAdHere: "TU ANUNCIO AQUÍ",
    mkDevice: "DISPOSITIVO",
    mkLanguage: "IDIOMA",
    mkTopCountries: "PAÍSES PRINCIPALES",
    mkFooterTitle: "Pon tu marca frente a esta audiencia",
    mkFooterDesc: "Patrocina un nivel, una valla o un reto diario en Nica Bros.",
    mkFooterCta: "Conviértete en patrocinador → nicabros.com",
    mkLockedTitle: "Kit de Medios Privado",
    mkLockedBody: "Este reporte para patrocinadores es privado. El enlace puede ser inválido o haber sido revocado. Contacta al equipo de Nica Bros para obtener acceso.",
    mkLoading: "CARGANDO…",
    mkLinkCopied: "¡Enlace privado copiado!",
    mkCopyFail: "No se pudo copiar",
    colUsername: "Usuario",
    colEmail: "Correo",
    colRole: "Rol",
    colJoined: "Registro",
    noPlayers: "Aún no hay perfiles registrados.",
    becomeSponsor: "Alianzas de Marca",
    inviteFriends: "Invitar Amigos",
    weeklyWinners: "Ganadores Semanales",
    weekendTournament: "Torneos del Finde",
    weekendTournamentSub: "🏆 Plataformas + 🎣 Pesca",
    fishingTitle: "NicaBros Pesca",
    fishingSub: "Pescá por toda Nicaragua",
    newBadge: "NUEVO",
    weekendTournamentCta: "Torneo del Finde — ¡Unite y Ganá!",
    registerNow: "¡Registrate Ya!",
    tBadge: "TORNEO DEL FIN DE SEMANA",
    tWinTitle: "Ganá el premio de esta semana",
    tMenu: "Menú",
    tPastWinners: "Ganadores",
    tabPlatformer: "NicaBros",
    tabFishing: "Pesca",
    tPrizeSoon: "Revelación del premio pronto",
    tThisPrize: "PREMIO DE ESTA SEMANA",
    tBy: "por",
    tEndsIn: "Termina en",
    tJoined: "inscritos",
    tTop: "Top",
    tWinSuffix: "ganan",
    tYoureIn: "¡Estás dentro! Jugá para subir en la tabla.",
    tJoinBtn: "Unite al torneo de esta semana",
    tJoining: "Uniéndote…",
    tSignInEnter: "Iniciá sesión para entrar",
    tRejoinNote: "Debés unirte cada semana para ser elegible. Solo los jugadores inscritos pueden ganar.",
    tLiveLb: "TABLA EN VIVO (INSCRITOS)",
    tNoScores: "Aún no hay puntajes esta semana — ¡sé el primero!",
    tPicking: "Eligiendo ganadores…",
    tJoinSuccess: "🎉 ¡Estás en el torneo de esta semana! Jugá para liderar la tabla.",
    tJoinError: "No se pudo unir",
    defaultPrize: "🏆 Mejor jugador de la semana — ¡destacado en la tabla de posiciones!",
    openInBrowserMsg: "Para la mejor experiencia (videos, notificaciones e instalar el juego), abrí en tu navegador.",
    openInBrowserBtn: "Abrir",
    copyLink: "Copiar enlace",
    linkCopied: "¡Enlace copiado! Pegalo en Chrome o Safari.",
    iosHint: "Tocá el menú ⋯ y elegí \"Abrir en Safari\".",
    shareGame: "Compartir Juego",
    shareText: "¡Jugá Nica Bros, el juego pinolero de Nicaragua! 🇳🇮🎮 Invitá a tu familia y amigos.",
    shareCopied: "¡Link copiado! Compartilo con tu gente 🎮",
    shareSignInNudge: "Iniciá sesión para recibir crédito por cada amigo que se una 🎮",
    signInForCredit: "Iniciá sesión para que tus puntajes altos cuenten para regalos, sorteos y crédito por cada amigo que invitás.",
    signInCta: "Iniciar sesión",
    sharesCount: "Tus puntajes e invitaciones cuentan ✅",
    sponsorTitle: "PATROCINÁ NICA BROS",
    sponsorIntro: "¿Querés que tu marca aparezca en el juego? Dejanos tus datos y te contactamos.",
    brandPartnersHeading: "NUESTROS SOCIOS",
    brandPartnersVisit: "Visitar / Saber más",
    brandPartnersSwipe: "Deslizá para ver más",
    freeGiftsBadge: "REGALOS Y DESCUENTOS GRATIS",
    freeGiftsBadgePlay: "¡JUGÁ PARA GANAR!",
    freeGiftsTitle: "GANÁ REGALOS GRATIS 🎁",
    freeGiftsSubtitle: "¡Premios reales de nuestros socios, cada semana!",
    freeGiftsStep1: "Iniciá sesión (es gratis) para que tus puntajes cuenten.",
    freeGiftsStep2: "Jugá y hacé los puntajes más altos en los niveles.",
    freeGiftsStep3: "¡Los mejores de la semana aparecen en Ganadores Semanales y ganan regalos de nuestros socios!",
    freeGiftsSeeWinners: "Ver Ganadores Semanales",
    brandPartnersFormTitle: "¿Querés ser socio?",
    sponsorName: "Nombre",
    sponsorCompany: "Empresa",
    sponsorWhatsapp: "WhatsApp",
    sponsorEmail: "Correo electrónico",
    sponsorMessage: "Mensaje",
    sponsorWhatsCta: "Escribinos por WhatsApp",
    sponsorSend: "ENVIAR",
    sponsorThanks: "¡Gracias! Te contactaremos pronto. 🤝",
    sponsorsList: "PATROCINADORES INTERESADOS",
    noSponsors: "Aún no hay solicitudes.",
  },
  en: {
    arcade: "★ NICARAGUA ARCADE ★",
    subtitle: "A Nicaraguan adventure!",
    start: "► PLAY / START",
    scores: "★ SCORES",
    controls: "Move: ← → / A D · Jump: SPACE · Power: K · Dance: J",
    chooseChar: "CHOOSE YOUR CHARACTER",
    swipeHint: "Swipe to see more",
    back: "◄ BACK",
    playingWith: "Playing as",
    chooseLevel: "CHOOSE THE LEVEL",
    levelsSection: "LEVELS",
    bonusLevelsSection: "BONUS LEVELS",
    featuredLevelsSection: "FEATURED SPECIAL LEVELS",
    featuredBadge: "FEATURED",
    featuredLabel: "SPECIAL",
    couponOff: "OFF",
    sponsoredBy: "With",
    couponTeaser: (p) => `Complete the level to receive ${p}% off your next bill.*`,
    etBoardTitle: "$25 GIFT CARD",
    etBoardSub: (d) => `${d}-day challenge · #1 takes the gift card`,
    etBoardPrize: "PRIZE",
    etBoardPoweredBy: "Powered by NicaBros",
    etBoardEmpty: "No runs yet. Be the first!",
    etBoardPlayers: (n) => `${n} player${n === 1 ? "" : "s"} competing`,
    etBoardYou: "You",
    etBoardYourRank: (r, s) => `Your rank: #${r} · ${s} pts`,
    etBoardRegister: "Register to join the challenge",
    etBoardRegisterHint: "Only registered players enter the board and can win the gift card.",
    etScoreSaved: "Your run is in the Gift Card Challenge!",
    etScorePending: (s) => `Your run: ${s} pts — register to enter the challenge and compete for the gift card.`,
    etViewBoard: "View board",
    gcRules: "EXTREME MODE · complete the level · fastest time · most 🍺 & points · fewest hits",
    gcFormula: (b, t, d) => `Points = score + 🍺×${b} + time bonus (${t}/sec) − ${d} per hit`,
    gcPlay: "PLAY THE CHALLENGE (EXTREME)",
    gcPlayHint: "The challenge is played on Extreme. Complete the level to enter the board.",
    gcEntryLine: (r, p) => `Rank #${r} · ${p} pts`,
    gcTryChallenge: "Want the $25 gift card? Play the Challenge on Extreme mode.",
    gcColTime: "Time",
    gcColBeers: "🍺",
    gcColHits: "Hits",
    discountsUnlocked: "discounts",
    discountsBtn: "Brand discounts",
    signInForDiscounts: "Sign in to see discounts",
    leadCapturePrompt: "Just want deals & updates? Leave your email",
    leadCaptureBtn: "Send",
    leadCaptureThanks: "Thanks! We'll email you news & discounts.",
    changeChar: "◄ CHANGE CHARACTER",
    level: "LEVEL",
    locked: "Locked",
    play: "Play",
    volcanoBonus: "BONUS: VOLCANO",
    volcanoBonusName: "Volcano Boarding · Cerro Negro",
    bonusLockedHint: "Finish all 3 levels to unlock",
    playBonus: "▶ PLAY BONUS",
    rodeoBonus: "BONUS: RODEO",
    rodeoBonusName: "Monta de Toros · Nica Rodeo",
    rodeoTitle: "NICA RODEO",
    rodeoTimeLeft: "HOLD ON",
    rodeoBalance: "BALANCE",
    rodeoSteerHint: "to keep your balance",
    rodeoThrown: "BUCKED OFF!",
    rodeoSurvived: "You lasted",
    rodeoExtraChance: "You've got one more shot!",
    rodeoRideAgain: "RIDE AGAIN",
    rodeoPerfect: "CHAMPION RIDER!",
    rodeoResultTitle: "GOOD RIDE!",
    rodeoLevelCard: "LEVEL 7",
    rodeoLevelCardName: "Corrida de Toros",
    rodeoLevelName: "RODEO LEVEL",
    rodeoLevelGoal: "REACH THE FINISH!",
    rodeoBossLabel: "FINAL BOSS!",
    rodeoChampion: "CHAMPION!",
    rodeoBossBeaten: "You beat the Rodeo Boss!",
    rodeoShare: "📲 SHARE MY RUN",
    rodeoJump: "JUMP",
    rodeoDuck: "DUCK",
    rodeoMove: "MOVE",
    backToMenu: "MENU",
    rodeoBest: "Best",
    topScores: "★ TOP SCORES ★",
    loading: "Loading...",
    loadingGame: "LOADING...",
    noScores: "Nobody has played yet! Be the first.",
    name: "NAME",
    pts: "PTS",
    menu: "◄ MENU",
    win: "YOU WIN!",
    gameOver: "GAME OVER",
    finalScore: "FINAL SCORE",
    beersLabel: "Beers",
    yourName: "YOUR NAME",
    saving: "SAVING...",
    saveScore: "★ SAVE SCORE",
    saved: "Score saved! 🎉",
    nextLevel: "► NEXT LEVEL",
    playOnTier: (label) => `► PLAY ON ${label} (+coins)`,
    coinsEarned: (n) => `🪙 +${n} coins`,
    gigantonaRewardTitle: "YOU UNLOCKED LA GIGANTONA!",
    gigantonaRewardBody: "You beat the Level 3 grandma boss! La Gigantona is yours FREE. 🎉",
    gigantonaRewardCta: "AWESOME, LET'S PLAY!",
    rewardFreeTag: "FREE!",
    langAutoToast: "Language: English · tap ES/EN at the top to change",
    partnerCodeLabel: "CODE",
    partnerShowCode: "Show discount code",
    partnerPopupTitle: "Thank you for being part of the NicaBros Community!",
    partnerPopupBody: (brand) => `Show this code at ${brand} for your NicaBros player discount.`,
    partnerPopupBodyGeneric: "Show this code for your NicaBros player discount.",
    partnerVisit: "Visit site",
    partnerClose: "Close",
    partnersPageTitle: "See NicaBros Network & Brand Partners Gifts & Discounts",
    partnersPageSub: "Show these codes to our partners and get gifts & discounts for being a NicaBros player.",
    partnersGateTitle: "🎁 Exclusive gifts & discounts",
    partnersGateBody: "Create your free account and sign in to see all the NicaBros Network & Brand Partner gifts and discounts.",
    partnersGcTitle: "MONTHLY $25 PARTNER GIFT CARDS",
    partnersGcSub: "Play the partner's level on Extreme: the highest score in 30 days wins the $25 gift card.",
    partnersGcTeaser: "+ Monthly $25 gift cards from our partners",
    partnersGateLogin: "Sign in / Sign up",
    partnersWeeklyTitle: "🔒 Weekly access",
    partnersWeeklyBody: "Sign in again this week to view the discounts. Come back weekly for new deals!",
    partnersWeeklyBtn: "Sign in again",
    partnersEmpty: "Partner discounts coming soon. Check back soon!",
    partnersShareCopy: "Copy link",
    partnersShareWhats: "Share on WhatsApp",
    partnersShareMsg: "🎮🎁 Check out the NicaBros partner discounts! Play and show your code to save:",
    partnersLinkCopied: "Link copied!",
    rewardUnlockedTitle: (name) => `YOU UNLOCKED ${name}!`,
    rewardUnlockedBody: (name) => `You beat the boss and earned a FREE character! You can now play as ${name}. 🎉`,
    level3Reward: "🎁 Beat the boss → La Gigantona FREE",
    level7Reward: "🎁 Beat the bull → El Enano Cabezón FREE",
    freeCharBadge: "🎁 FREE CHARACTER",
    collectionTitle: "Character Collection",
    collectionBtn: "Collection",
    collectionNudge: "🔓 New unlock nearby!",
    storyChallenges: "🎵 Your Journey in NicaBros!",
    challengeLeonName: "The Roar of León",
    challengeLeonDesc: "Beat Level 4 (León) as JavyDade",
    challengeBluefieldsName: "Bluefields Rhythm",
    challengeBluefieldsDesc: "Complete Level 5 (Bluefields) as NicaFlow",
    challengeComplete: "✓ Completed!",
    challengeLocked: "🔒 Locked",
    badgeEarnedTitle: "BADGE UNLOCKED!",
    badgeEarnedBody: (name) => `You completed the "${name}" challenge. Badge added to your collection! 🎉`,
    badgeEarnedCta: "AWESOME!",
    collectionProgress: (n, total) => `${n} / ${total} unlocked`,
    collectionUnlocked: "✓ Unlocked",
    unlockBeatLevel: (n) => `🎁 Beat Level ${n}`,
    unlockFreeChar: "Free",
    collectionHint: "Unlock them all! Earn coins by playing or beat the bosses.",
    retry: "↻ RETRY",
    playManagua: "► PLAY MANAGUA",
    pauseTitle: "PAUSE",
    resume: "► CONTINUE",
    fiesta: "FIESTA",
    fiestaOn: "FIESTA!",
    jefa: "★ THE BOSS ★",
    music: "MUSIC",
    chooseSong: "CHOOSE YOUR SONG",
    close: "CLOSE",
    autoMusic: "Auto (per level)",
    tag_dongregorio: "Mr Positivity",
    desc_dongregorio: "Runs super fast, jumps higher, double jump and dash (K).",
    tag_chasedawson: "Nicaragua Baseball Player",
    desc_chasedawson: "Bashes a home run (K) that flies out and knocks down enemies.",
    power_chasedawson: "HOME RUN",
    tag_jorge: "Curious123 Soccer Camps",
    desc_jorge: "Kicks 3 soccer balls (K) at once to knock down enemies.",
    tag_laborracha: "Queen Of The Party",
    desc_laborracha: "Throws beer bottles (K) to knock out enemies from afar.",
    tag_ranchero: "The Pinolero Cowboy",
    desc_ranchero: "Runs fast, double jump, and swings a long-reach MACHETE (K).",
    tag_surfista: "The San Juan Legend",
    desc_surfista: "Agile surfer who lands a KARATE CHOP (K) on enemies in front.",
    tag_pandillero: "The Barrio's Slickest",
    desc_pandillero: "Throws rocks (K) to knock down enemies from afar.",
    tag_influencer: "Pancho Rides",
    tag_nicaflow: "Follow me on TikTok",
    desc_influencer: "Kicks soccer balls (K) that knock down enemies. SUPER FAST + DOUBLE JUMP!",
    tag_angelmick: "New Music Out Now",
    desc_angelmick: "Sings music notes (K) that knock down enemies. SUPER FAST + DOUBLE JUMP!",
    tag_gueguense: "The Masked Trickster",
    desc_gueguense: "TRIPLE JUMP + throws magic maracas (K) that knock down enemies. Great for hard levels!",
    tag_gigantona: "Queen Of The Carnival",
    desc_gigantona: "Sky-high TRIPLE JUMP + a fast SPIN (K) that knocks out enemies all around her. Dominate any level!",
    power_influencer: "BALL BLAST",
    power_angelmick: "MUSIC NOTES",
    power_dongregorio: "FRITANGAZO",
    power_ranchero: "MACHETE SLASH",
    power_pandillero: "ROCK THROW",
    power_laborracha: "BOTTLE THROW",
    power_jorge: "TRIPLE BALL KICK",
    power_surfista: "KARATE CHOP",
    power_gueguense: "MAGIC MARACAS",
    power_gigantona: "GIANT SPIN",
    power_javydade: "NACATAMALAZO",
    tag_javydade: "New Music Out Now",
    desc_javydade: "Throws nacatamales (K) that knock down enemies. SUPER FAST + DOUBLE JUMP!",
    link_javydade: "Follow @JavyDade",
    act_nacatamal: "Throws Nacatamales",
    act_fritanga: "Throws Fritangas",
    act_throw: "Throws Bottles",
    act_ball: "Kicks Footballs",
    actTriplePlay: "Triple Play",
    powerTriplePlay: "TRIPLE PLAY",
    act_homerun: "Bashes a Home Run",
    act_notes: "Music Notes",
    act_rock: "Throws Rocks",
    act_machete: "Machete Slash",
    act_chop: "Karate Chop",
    act_strength: "Ground Pound",
    act_speed: "Speed Dash",
    tag_elvin: "The Prodigy",
    link_elvin: "Follow ElvinEspinoza",
    power_elvin: "RIGHT HOOK",
    desc_elvin: "Fires electric bolts (K) from his glove that knock down enemies. SUPER FAST + DOUBLE JUMP!",
    act_electric: "Electric Bolts",
    tag_nacatamal: "Nacatambuche",
    power_nacatamal: "BREAD SMASH",
    desc_nacatamal: "Super fast with a double jump! Throws bread (K) that knocks down enemies.",
    act_bread: "Throws Bread",
    tag_enanocabezon: "La Gigantona's Partner",
    power_enanocabezon: "HEADBUTT",
    desc_enanocabezon: "Lands a headbutt (K) that knocks out enemies in front. Double jump!",
    act_headbutt: "Headbutt",
    tag_elespanol: "From the Toro Huaco",
    power_elespanol: "MAGIC RATTLE",
    desc_elespanol: "Throws morro maracas (K) to knock down enemies from afar. Triple jump!",
    act_rattle: "Throws the Rattle",
    act_maraca: "Throws Maracas",
    act_spin: "Fast Spin",
    tabVolcano: "Volcano",
    tabOcean: "Dive",
    bonusTop5: "TOP 5",
    bossLevelBadge: "SPECIAL BOSS",
    perkDoubleJump: "Double Jump",
    perkTripleJump: "Triple Jump",
    perkSuperFast: "Super Fast",
    perkFast: "Fast",
    influencedBy: "Influenced by",
    soundtrack: "Listen on Spotify",
    link_dongregorio: "Visit My Website",
    giftsBanner: "🎁 COMING SOON: top players will win FREE gifts from our partners & sponsors!",
    settings: "SETTINGS",
    soundLabel: "Sound",
    soundOn: "On",
    soundOff: "Off",
    musicVolume: "Music Volume",
    sfxVolume: "SFX Volume",
    restartLevel: "↻ RESTART LEVEL",
    exitToMenu: "✕ EXIT TO MENU",
    shareGame: "📣 SHARE NICA BROS",
    shareWin: "📣 SHARE YOUR WIN",
    shareScore: "📤 SHARE YOUR SCORE",
    linkCopied: "Link copied! Share it with your friends 🎉",
    shareText: "I'm playing Nica Bros 🇳🇮 — a Nicaraguan platformer adventure! Come play with me 🎮",
    shareWinText: "I scored {score} in Nica Bros 🇳🇮 playing as {char}! Can you beat me? 🎮",
    bonusTitle: "🌋 VOLCANO BOARDING",
    bonusSub: "Ride down Cerro Negro and grab córdobas!",
    bonusPromptTitle: "VOLCANO BOARDING BONUS!",
    bonusPromptBody: "Board down Cerro Negro and grab extra córdobas for your score. Want to play it?",
    bonusPlay: "PLAY BONUS",
    bonusSkip: "Skip",
    bonusReady: "GET READY!",
    bonusSteer: "◄ ► to steer",
    cordobas: "CÓRDOBAS",
    bonusResultTitle: "AWESOME RIDE!",
    bonusResultMsg: "You grabbed {n} of 100 córdobas",
    bonusBonus: "BONUS",
    continueBtn: "► CONTINUE",
    bonusPerfect: "PERFECT! 💯",
    cordobasCol: "C$",
    attemptOf: (n) => `ATTEMPT ${n} OF 2`,
    bonusCountGo: "GO!",
    bestSoFar: "Best so far",
    oceanBonus: "BONUS: DIVE",
    oceanBonusName: "Treasure Dive · Corn Island",
    oceanLockedHint: "Beat Corn Island to unlock",
    oceanPromptTitle: "TREASURE DIVE BONUS!",
    oceanPromptBody: "Swim deeper, grab córdobas, dodge the fish and reach the treasure chest to win the gold NicaBros trophy. Want to play it?",
    oceanTitle: "🌊 TREASURE DIVE",
    oceanSteer: "◄ ► ▲ ▼ to swim",
    oceanDepth: "Dive deeper!",
    oceanResultTitle: "TREASURE FOUND!",
    trophyTitle: "GOLD NICABROS TROPHY",
    trophySaved: "🏆 Trophy saved to your profile",
    trophySignin: "Sign in to save your trophy",
    diveKO: "KNOCKED OUT!",
    diveKOBody: "3 fish knocked you out. You get one more try to finish from where you left off!",
    diveContinueHere: "CONTINUE FROM HERE",
    diveKOFinal: "KNOCKED OUT!",
    diveKOFinalBody: "No tries left. You keep the córdobas you collected!",
    hapticsLabel: "Vibration",
    sectionFood: "Auténtica de Comida",
    act_cream: "Squirts Cream",
    act_tornado: "Throws Tornados",
    tag_mercado: "El Unico OneTime",
    power_mercado: "Right Hand KO",
    link_mercado: "Follow @TheOnlyDanielMercado",
    tag_isaacreyes: "Actor & Singer",
    power_isaacreyes: "STAR POWER",
    link_isaacreyes: "Follow @IsaacReyes",
    act_starnote: "Stars & Music Notes",
    act_hypno: "Hypnotize Punch",
    tag_jahoskachamorro: "Queen of the Ring",
    power_jahoskachamorro: "HYPNOTIZE PUNCH",
    link_jahoskachamorro: "Follow @JahoskaChamorro",
    attemptDone: (n) => `ATTEMPT ${n} DONE!`,
    ready2nd: "You have one more try. Ready?",
    start2nd: "► 2ND TRY",
    difficulty: "DIFFICULTY",
    diffFacil: "EASY",
    diffNormal: "NORMAL",
    diffExtremo: "EXTREME",
    diffFacilDesc: "More lives, slow enemies",
    diffNormalDesc: "The classic challenge",
    diffExtremoDesc: "☠️ Brutal: few lives, everything faster",
    newBest: "NEW BEST!",
    best: "Best",
    dailyChallenge: "DAILY CHALLENGE",
    today: "Today",
    newRecord: "NEW TIME!",
    tabTop: "TOP",
    tabDaily: "DAILY",
    tabSpeedrun: "SPEEDRUN",
    timeCol: "TIME",
    shareRank: "📣 SHARE MY RANK",
    shareGeneric: "📣 SHARE BOARD",
    rankShareText: (r, s) => `I'm #${r} on Nica Bros with ${s} points! 🇳🇮 Can you beat me?`,
    boardShareText: "Play Nica Bros and climb the leaderboard! 🇳🇮🍺",
    rankShared: "Shared! 🎉",
    rankCopied: "Copied to clipboard! 🎉",
    cardSaved: "Image saved & link copied! Paste it in WhatsApp or Instagram so they can play 📲",
    cardShareFail: "Couldn't share. Please try again.",
    notRanked: "Play a round to get on the board 🎮",
    installTitle: "Save Nica Bros to your phone!",
    installBenefit: "📲 It plays WAY better from your phone! Full-screen, faster, no browser bar, and one tap to play.",
    installSubtitle: "The game is best played when it's saved to your phone. Full-screen and one tap to play!",
    installIos1: "Tap the Share button (the box with an ↑ arrow) at the bottom of Safari.",
    installIos2: "Scroll down and tap \u201CAdd to Home Screen\u201D.",
    installIos3: "Tap \u201CAdd\u201D \u2014 then open Nica Bros from your home screen!",
    installAndroid1: "Tap the \u22EE menu (top-right of Chrome).",
    installAndroid2: "Tap \u201CAdd to Home screen\u201D or \u201CInstall app\u201D.",
    installAndroid3: "Tap \u201CAdd\u201D \u2014 then open Nica Bros from your home screen!",
    installDesktop1: "Click the install icon \u2295 in the address bar.",
    installDesktop2: "Click \u201CInstall\u201D to save it as an app.",
    installGotIt: "GOT IT, LET'S PLAY!",
    giftsTitle: "🎁 Win weekly gifts!",
    giftsBody: "Sign up and turn on notifications to find out if you're a weekly winner of our sponsor gifts.",
    giftsSignup: "Sign up — it's free!",
    giftsSignedIn: "You're signed in ✓",
    allowNotifs: "Allow notifications",
    notifsOn: "Notifications on ✓",
    competingForGift: "players competing for this week's gift",
    tabGifts: "🎁 Gifts",
    tabInstall: "📱 Save app",
    otherDevice: "Other device?",
    installLater: "Maybe later",
    yourDevice: "Your device",
    saveAs: "Save as",
    loginToSave: "Create a profile to save your score to the leaderboard 🏆",
    createProfileSave: "Create profile / Sign in",
    scoreEmailCta: "Want game reminders? 🔔",
    scoreEmailPlaceholder: "Your email",
    scoreEmailBtn: "Save",
    scoreEmailThanks: "Done! We'll send you reminders. 🔔",
    scoreEmailInvalid: "Enter a valid email",
    scoreEmailFail: "Couldn't save, please try again",
    orCreateProfile: "or create a profile to save your score 🏆",
    titleSettings: "SETTINGS",
    saveToPhone: "Save to my phone",
    shareGame: "Share Nica Bros",
    language: "Language",
    howToPlay: "How to play",
    settingsHelp: "Move with ← → (or A/D), jump with SPACE, use your power with K and dance with J.",
    dailyReminders: "Daily reminders",
    remindersEnabled: "Reminders on! 🔔",
    remindersDisabled: "Reminders off",
    remindersDenied: "Notification permission denied",
    remindersUnsupported: "On iOS, add the game to your home screen first to enable notifications.",
    notifyOptInTitle: "Turn on notifications!",
    notifyOptInBody: "Get alerts for weekly prizes, new levels and challenges from your friends. Don't miss out!",
    notifyOptInYes: "Turn on notifications",
    notifyOptInLater: "Not now",
    notifyOptInDone: "Notifications on! 🔔",
    notifyOptInFail: "Couldn't enable notifications",
    finaleTag: "NICARAGUA COMPLETE!",
    finaleTitle: "YOU DID IT!",
    levelCompleteTag: "LEVEL COMPLETE!",
    levelCompleteTitle: "NICELY DONE!",
    levelUnlocked: (n) => `🌋 Unlocked: ${n}!`,
    ptsShort: "pts",
    level4Soon: "Level 4 — Coming Soon!",
    level4Help: "Help us create the next level and the new characters. Your idea could make it into the game!",
    helpCreate: "HELP CREATE LEVEL 7",
    finishedThanksTitle: "YOU BEAT NICA BROS!",
    finishedThanksBody: "Thank you for your support! 🇳🇮 Leave us a review and tell us what you think.",
    rateGame: "RATE THE GAME",
    reviewIntroFinish: "You finished all 4 levels! 🎉 Thanks for playing. Leave your public review.",
    shareVictory: "Share my victory",
    victoryShareText: (c, s) => `I beat Nica Bros with ${c} scoring ${s} points! 🇳🇮🏆 Can you top me?`,
    signIn: "SIGN IN",
    signUp: "SIGN UP",
    username: "Username",
    age: "Age",
    ageError: "Please enter a valid age.",
    email: "Email",
    password: "Password",
    lockedChar: "LOCKED",
    comingSoon: "COMING SOON!",
    comingSoonBadge: "SOON",
    guestStar: "Special Invitation",
    newBadge: "NEW",
    newCharsTitle: "NEW CHARACTERS!",
    newCharsBody: "New characters are now available. Pick yours and jump in!",
    newLevelTitle: "NEW LEVEL + BONUS!",
    newCharsCta: "PLAY NOW",
    newCharsLater: "Not now",
    sectionGuests: "Special Guests Nicaragüense",
    sectionInvited: "Special Invited Characters",
    sectionCultural: "Cultural Characters",
    sectionOriginals: "Original Characters",
    inviteToUnlock: (n) => `Invite ${n} friends`,
    coins: "coins",
    coinBalance: (n) => `🪙 ${n} coins`,
    unlockForCoins: (n) => `Unlock · ${n} 🪙`,
    notEnoughCoins: "Not enough coins yet",
    dailyCoinEarned: "🪙 +1 coin for playing today!",
    dailyStreakToast: (n) => `🔥 ${n}-day streak! +1 coin`,
    streakBonusToast: (b) => `🎁 Streak bonus! +${b} coins`,
    streakBadgeTitle: "Daily streak — come back every day!",
    earnCoinsHint: "Earn 1 coin a day · 5 for your first friend, +1 for each friend after",
    charUnlocked: (name) => `🔓 You unlocked ${name}!`,
    charUnlockedDesc: "Your invites paid off. This character is ready to play!",
    challengeStartToast: (n, s) => `🎯 Beat ${n}: ${s} pts!`,
    challengeYouWon: (n) => `🏆 You beat ${n}!`,
    challengeYouLost: (n, s) => `So close! ${n} scored ${s} pts — try again!`,
    challengeShareText: (s) => `I challenge you in Nica Bros 🇳🇮 — I scored ${s} pts. Can you beat me? Play here:`,
    signInToUnlock: "Sign in to earn and spend coins",
    noAccount: "No account? Sign up",
    haveAccount: "Have an account? Sign in",
    suggestIdeas: "SUGGEST IDEAS",
    suggestSignIn: "Sign in to suggest an idea",
    ideasTitle: "COMMUNITY IDEAS",
    ideaTitle: "Your idea title",
    ideaDesc: "Describe your idea (optional)",
    addIdea: "ADD IDEA",
    ideaThanks: "Thanks for your idea! 🎉",
    deleteIdea: "Delete idea",
    clearAllIdeas: "Delete all ideas",
    ideaDeleted: "Idea deleted",
    confirmDeleteIdea: "Delete this idea?",
    confirmDeleteAllIdeas: "Delete ALL ideas? This cannot be undone.",
    noIdeas: "Be the first to suggest!",
    cat_all: "All",
    cat_level: "Level",
    cat_boss: "Boss",
    cat_feature: "Feature",
    send: "SEND",
    cancel: "CANCEL",
    adminTitle: "ADMIN PANEL",
    adminDenied: "Access denied",
    activeNow: "Active now",
    playersToday: "Players today",
    playersWeek: "This week",
    playersMonth: "This month",
    minutesToday: "Minutes today",
    hoursTotal: "Hours total",
    registeredUsers: "Registered",
    sessionsAll: "Sessions",
    refresh: "REFRESH",
    emailDigest: "EMAIL ME DIGEST",
    digestSent: "Digest sent to",
    resetScores: "RESET SCORES",
    confirmResetScores: "Delete ALL scores? This resets the leaderboard and cannot be undone.",
    scoresReset: "Scores reset",
    playersList: "REGISTERED PROFILES",
    exportCsv: "EXPORT CSV",
    brandPartnersSwipe: "Swipe to see more",
    mkBizTitle: "Become a Brand Partner",
    mkBizIntro: "Own a business? Offer a discount to Nica Bros players and get featured on our in-game billboards.",
    mkBizWhatsappNote: "After you apply, message us on WhatsApp to connect, send your image/video and discuss the discount. We upload and approve your billboard to make the partnership official.",
    mkBizConnectWhatsapp: "Connect on WhatsApp",
    mkBizCompany: "Company name",
    mkBizCity: "City",
    mkBizOffer: "Your offer / discount",
    mkBizCode: "Staff code (players show it to claim)",
    mkBizExpires: "Offer expires",
    mkBizLink: "Link to share with players",
    mkBizWhatsappField: "Your WhatsApp",
    mkBizEmail: "Your email",
    mkBizName: "Your name",
    mkBizSubmit: "Apply to partner",
    mkBizThanks: "Thanks! We'll review your offer and reach out.",
    mkStatVisitors: "Total visitors",
    mkStatSessions: "Total sessions",
    mkStatGames: "Games played",
    mkLiveData: "Live data · auto-updated. As of",
    mkSponsorMediaKit: "Sponsor Media Kit",
    mkCopyLink: "Copy link",
    mkSavePdf: "Save PDF",
    mkReportSubtitle: "Audience & Reach Report",
    mkUpdated: "Updated",
    mkStatTotalPlayers: "Total players",
    mkStatMonthlyActive: "Monthly active",
    mkStatThisWeek: "this week",
    mkStatPlayHours: "Play-hours",
    mkStatScreenTime: "total screen time",
    mkStatAvg: "avg",
    mkAdInventoryTitle: "In-game ad inventory",
    mkAdInventoryDesc: "Estimated billboard impressions per city level — your brand on the in-game signs.",
    mkColLevelCity: "LEVEL / CITY",
    mkColImpressions: "AD IMPRESSIONS",
    mkColPlayers: "PLAYERS",
    mkColExposure: "EXPOSURE (MIN)",
    mkNoLevelData: "No level data yet.",
    mkImpressionsLabel: "ad impressions",
    mkBillboardsTitle: "Billboard slots (2 per level)",
    mkBbDescA: "Each city has a ",
    mkSlotStartWord: "START",
    mkBbDescB: " (level intro) and a premium ",
    mkSlotEndWord: "END",
    mkBbDescC: " (right before the goal — peak attention) billboard. Reserve a position below.",
    mkSlotEnd: "END · before goal",
    mkSlotStart: "START · level intro",
    mkBooked: "BOOKED",
    mkReserve: "RESERVE",
    mkYourAdHere: "YOUR AD HERE",
    mkDevice: "DEVICE",
    mkLanguage: "LANGUAGE",
    mkTopCountries: "TOP COUNTRIES",
    mkFooterTitle: "Put your brand in front of this audience",
    mkFooterDesc: "Sponsor a level, a billboard or a daily challenge in Nica Bros.",
    mkFooterCta: "Become a sponsor → nicabros.com",
    mkLockedTitle: "Private Media Kit",
    mkLockedBody: "This sponsor report is private. The link may be invalid or has been revoked. Please contact the Nica Bros team for access.",
    mkLoading: "LOADING…",
    mkLinkCopied: "This private link copied!",
    mkCopyFail: "Could not copy",
    colUsername: "Username",
    colEmail: "Email",
    colRole: "Role",
    colJoined: "Joined",
    noPlayers: "No registered profiles yet.",
    becomeSponsor: "Brand Partnerships",
    inviteFriends: "Invite Friends",
    weeklyWinners: "Weekly Winners",
    weekendTournament: "Weekend Tournaments",
    weekendTournamentSub: "🏆 Platformer + 🎣 Fishing",
    fishingTitle: "NicaBros Fishing",
    fishingSub: "Fish across Nicaragua",
    newBadge: "NEW",
    weekendTournamentCta: "Weekend Tournament — Join & Win",
    registerNow: "Register Now!",
    tBadge: "WEEKEND TOURNAMENT",
    tWinTitle: "Win this week's prize",
    tMenu: "Menu",
    tPastWinners: "Past winners",
    tabPlatformer: "NicaBros",
    tabFishing: "Fishing",
    tPrizeSoon: "Prize reveal coming soon",
    tThisPrize: "THIS WEEK'S PRIZE",
    tBy: "by",
    tEndsIn: "Ends in",
    tJoined: "joined",
    tTop: "Top",
    tWinSuffix: "win",
    tYoureIn: "You're in! Play now to climb the leaderboard.",
    tJoinBtn: "Join this week's tournament",
    tJoining: "Joining…",
    tSignInEnter: "Sign in to enter",
    tRejoinNote: "You must join every week to be eligible. Only enrolled players can win.",
    tLiveLb: "LIVE LEADERBOARD (ENROLLED)",
    tNoScores: "No scores yet this week — be the first to set one!",
    tPicking: "Picking winners…",
    tJoinSuccess: "🎉 You're in this week's tournament! Play to top the leaderboard.",
    tJoinError: "Could not join",
    defaultPrize: "🏆 Top player of the week — featured on the leaderboard!",
    openInBrowserMsg: "For the best experience (videos, notifications & installing the game), open in your browser.",
    openInBrowserBtn: "Open",
    copyLink: "Copy link",
    linkCopied: "Link copied! Paste it into Chrome or Safari.",
    iosHint: "Tap the ⋯ menu and choose \"Open in Safari\".",
    shareGame: "Share Game",
    shareText: "Play Nica Bros — the Nicaragua arcade game! 🇳🇮🎮 Invite your family and friends.",
    shareCopied: "Link copied! Share it with your people 🎮",
    shareSignInNudge: "Sign in to get credit for every friend who joins 🎮",
    signInForCredit: "Sign in so your high scores count towards gifts, giveaways and credit for every friend you invite.",
    signInCta: "Sign in",
    sharesCount: "Your scores & invites count ✅",
    sponsorTitle: "SPONSOR NICA BROS",
    sponsorIntro: "Want your brand featured in the game? Leave your details and we'll reach out.",
    brandPartnersHeading: "OUR PARTNERS",
    brandPartnersVisit: "Visit / Learn More",
    brandPartnersSwipe: "Swipe to see more",
    freeGiftsBadge: "FREE GIFTS & DISCOUNTS",
    freeGiftsBadgePlay: "PLAY TO WIN!",
    freeGiftsTitle: "WIN FREE GIFTS 🎁",
    freeGiftsSubtitle: "Real prizes from our sponsors — every week!",
    freeGiftsStep1: "Sign in (it's free) so your scores count.",
    freeGiftsStep2: "Play and rack up high scores across the levels.",
    freeGiftsStep3: "Top players each week land on Weekly Winners and win sponsor gifts!",
    freeGiftsSeeWinners: "See Weekly Winners",
    brandPartnersFormTitle: "Want to partner with us?",
    sponsorName: "Name",
    sponsorCompany: "Company",
    sponsorWhatsapp: "WhatsApp",
    sponsorEmail: "Email",
    sponsorMessage: "Message",
    sponsorWhatsCta: "Message us on WhatsApp",
    sponsorSend: "SEND",
    sponsorThanks: "Thanks! We'll be in touch soon. 🤝",
    sponsorsList: "SPONSOR INQUIRIES",
    noSponsors: "No inquiries yet.",
  },
};

const LanguageContext = createContext(null);

// First-visit language: default to Spanish. Honor a saved choice if the user
// has explicitly switched via the ES/EN toggle.
function detectInitialLang() {
  try {
    const saved = localStorage.getItem("nicabros_lang");
    if (saved === "es" || saved === "en") return saved;
    return "es";
  } catch {
    return "es";
  }
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitialLang);
  const setLang = useCallback((l) => {
    localStorage.setItem("nicabros_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key, fallback) => (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.es[key] || fallback || key, [lang]);
  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  return useContext(LanguageContext);
}
